module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/20-039ecbaf76afb9169f1652c5a145623f.png";